import { requestGet } from '@/common/request';

export interface acceptedHistoryParams {
  activityId: string;
  currentPage: number;
  pageSize: number;
}

export interface acceptedHistoryRes {
  ret: string;
  msg: string;
  data: {
    currentPage: number;
    pageSize: number;
    totalCount: number;
    list:
      | Array<{
          historyId: number;
          inventoryId: string;
          inventoryName: string;
          creatorErp: string;
          operatedTime: number;
          subStrategyNames: Array<string> | [];
          rules: Array<{ type: number; value: Array<string> | [] }> | [];
          status: number;
        }>
      | [];
  };
}

//品类盘货 - 接收历史查看
export async function acceptedHistory(params: acceptedHistoryParams): Promise<acceptedHistoryRes> {
  return await requestGet('/goodsPool/acceptedHistory', params);
}
